import { render } from "./Attr.vue?vue&type=template&id=3206fddd&scoped=true"
import script from "./Attr.vue?vue&type=script&lang=js"
export * from "./Attr.vue?vue&type=script&lang=js"

import "./Attr.vue?vue&type=style&index=0&id=3206fddd&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3206fddd"

export default script